import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItemCheckbox } from 'components/Dropdown2';

const messages = defineMessages({
  label: {
    id: 'schedules.class-filter.label',
    defaultMessage: 'Classes',
  },
  selectedOptions: {
    id: 'schedules.class-filter.selected-options',
    defaultMessage: '{firstOption} {selectedClasses, select, 0 {} other {+ {selectedClasses}} }',
  },
});

const ScheduleBoardClassFilter = ({ classes, selectedClasses, updateSelection }) => {
  const intl = useIntl();

  const completeOptions = (classes || []).map(({ id, name }) => ({
    label: name,
    value: id,
    match: `${id} ${name}`,
  }));

  const completeSelectedClasses = (classes || []).filter(({ id }) => selectedClasses.includes(id));

  return (
    <Dropdown
      multiselect
      autocomplete
      closeOnSelect={false}
      options={completeOptions}
      selectedOption={{
        label: completeSelectedClasses.length
          ? intl.formatMessage(messages.selectedOptions, {
              firstOption: completeSelectedClasses[0].name,
              selectedClasses: completeSelectedClasses.length - 1,
            })
          : '',
      }}
      dataCypress="schedule-board-class-filter"
      disabled={!completeOptions.length}>
      <DropdownToggle label={messages.label} />
      <DropdownMenu>
        {data =>
          data.map(({ option, isHighlighted, ref }) => {
            const { label, value } = option;
            return (
              <DropdownItemCheckbox
                key={value}
                ref={ref}
                onClick={checked => {
                  const updatedArr = checked
                    ? selectedClasses.concat(value)
                    : selectedClasses.filter(opt => opt !== value);
                  updateSelection(updatedArr);
                }}
                isHighlighted={isHighlighted}
                isChecked={selectedClasses.includes(value)}>
                {label}
              </DropdownItemCheckbox>
            );
          })
        }
      </DropdownMenu>
    </Dropdown>
  );
};

ScheduleBoardClassFilter.propTypes = {
  classes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  selectedClasses: PropTypes.arrayOf(PropTypes.number),
  updateSelection: PropTypes.func,
};

export default ScheduleBoardClassFilter;
